import type { FormikErrors } from 'formik';
import type { TariffApplicationFormValues } from './types';

type TranslateFn = (key: string) => string;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const isEmpty = (value: string): boolean => !String(value || '').trim();

export const validateApplication = (
    values: TariffApplicationFormValues,
    t: TranslateFn,
): FormikErrors<TariffApplicationFormValues> => {
    const errors: FormikErrors<TariffApplicationFormValues> = {};

    if (isEmpty(values.companyName)) errors.companyName = t('application.messEmptyCompanyName');
    if (isEmpty(values.taxId)) errors.taxId = t('application.messEmptyTaxId');
    if (isEmpty(values.phone)) errors.phone = t('application.messEmptyPhone');
    if (isEmpty(values.email)) {
        errors.email = t('application.messEmptyEmail');
    } else if (!EMAIL_RE.test(values.email.trim())) {
        errors.email = t('application.messInvalidEmail');
    }
    if (isEmpty(values.legalAddress)) errors.legalAddress = t('application.messEmptyLegalAddress');
    if (isEmpty(values.representativeName)) {
        errors.representativeName = t('application.messEmptyRepresentativeName');
    }

    return errors;
};
